// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { routes, scrollBehavior } from './routes'
import store from '../store'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior
})

// Navigation guard to reset company state when navigating to companies page
router.beforeEach((to, from, next) => {
  // Reset company state when navigating to companies page
  if (to.name === 'CompaniesView') {
    store.commit('companyStore/RESET_COMPANY_STATE');
    // Note: Vuetify theme reset is handled in CompaniesView component
    // where we have access to the Vuetify instance
  }
  next();
})

export default router